<template>
  <div id="scantron" class="pt-3 page_indentation">
    <b-row class="indentation-left mb-3">
      <b-col
        ><h2 class="tsny_header">
          {{ courseId }} -- {{ exam.examName }}
        </h2></b-col
      >
    </b-row>
    <b-row class="indentation-left mb-5" style="{min-height: 40px}">
      <b-col
        ><p class="tsny_text border-bottom pb-3">
          Use the Scantron below to produce a score report for the practice test
          you selected from the menu. Use your mouse to select the answer you
          selected for each question. Once you've done so, click submit, and
          you'll see a report containing your aggregate score, your score on
          each section, and your performance on different kinds of questions and
          subject material on the exam. Your tutor is always available to help
          If you have any questions about how to use this feature or how to
          interpret your score report.
        </p></b-col
      >
    </b-row>
    <b-row>
      <b-col>
        <b-row>
          <b-col style="position: relative">
            <b-row
              v-for="section in sections"
              :key="section.subsection || section.section"
              class="mb-5"
            >
              <exam-section
                :id="generateNavLink(section)"
                :section="section"
                :creating-exam="creatingExam"
                :category-options="categoryOptions"
                :window-width="windowWidth"
              />
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="col-auto ml-3">
        <ExamNav
          :color="color"
          :sections="mappedSections"
          :submit-event="submitEvent"
        /> </b-col
    ></b-row></div
></template>

<script>
import { _ } from "vue-underscore";
import ExamNav from "./ExamNav";
import EventConstants from "../../services/eventBus/EventConstants";
import ExamSection from "./ExamSection";

export default {
  name: "Scantron",
  components: { ExamSection, ExamNav },
  props: {
    courseId: {
      type: String,
      default: null
    },
    exam: {
      type: Object,
      default: null
    },
    questionCategories: {
      type: Array,
      default: null
    },
    color: {
      type: String,
      default: "#191919"
    },
    creatingExam: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    mappedSections() {
      if (!this.sections) return [];

      return this.sections.map(section => ({
        section: section.section,
        ...(section.subsection && { subsection: section.subsection })
      }));
    },
    submitEvent() {
      if (this.creatingExam) {
        return EventConstants.EVENTS.EXAM_UPDATED;
      } else {
        return EventConstants.EVENTS.EXAM_SUBMITTED;
      }
    },
    categoryOptions() {
      return this.creatingExam
        ? _.map(this.questionCategories, category => ({
            value: category.name,
            text: category.name,
            subcategories: _.map(
              category.subcategories,
              subcategory => subcategory.name
            )
          }))
        : [];
    }
  },
  data() {
    return {
      sections: null,
      windowWidth: window.innerWidth
    };
  },
  mounted() {
    this.sections = this.exam.sections;
    window.addEventListener("resize", this.widthHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.widthHandler);
  },
  methods: {
    generateNavLink(section) {
      return section.subsection
        ? section.subsection === "No Calculator"
          ? "noCalculator"
          : section.subsection
        : section.section;
    },
    widthHandler() {
      this.windowWidth = window.innerWidth;
    }
  }
};
</script>

<style scoped></style>
